import { Storage } from '../utils.jsx'

const PLAYER_ID_KEY = 'communityStatsPlayerId'

function createPlayerId() {
  if (crypto.randomUUID) {
    return crypto.randomUUID()
  }

  const values = crypto.getRandomValues(new Uint32Array(4))
  return Array.from(values, (value) => value.toString(16).padStart(8, '0')).join('-')
}

export function getPlayerId() {
  const savedPlayerId = Storage.getFromLocalStorage(PLAYER_ID_KEY)
  if (savedPlayerId) {
    return savedPlayerId
  }

  const playerId = createPlayerId()
  Storage.saveToLocalStorage(PLAYER_ID_KEY, playerId)
  return playerId
}

export async function submitPuzzleCompletion({
  puzzleNumber,
  gameMode,
  score,
}) {
  const response = await fetch(
    `/api/puzzles/${puzzleNumber}/${gameMode}/completions`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ playerId: getPlayerId(), score }),
    },
  )

  if (!response.ok) {
    throw new Error(`Community stats request failed with ${response.status}`)
  }

  return response.json()
}
